import React from "react";
 import StablePrime from "../components/Tables/StablePrime";

function UpdateCp1Ppm5sIapf({ setPageHeader }) {
  setPageHeader("Line");
  return (
    <div>
      <StablePrime url="/cp1update/ppm5siapf" data={{}} identity="perfparam" />
    </div>
  );
}

export default UpdateCp1Ppm5sIapf;